export enum PageLayoutVariant {
  PADDED = '--padded',
  FULL_SCREEN = '--full-screen',
  LOGGED_OUT = '--logged-out',
  ICON_NAV = '--padded --icon-nav',
}
